export default "__VITE_ASSET__CADDagKf__"